import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";

import { FeatureFlags } from "shared/reducers/sysReducer";

import ApplicationState from "store/ApplicationState";

export interface AdminLinkProps {
  title: string;
  route: string;
  children?: any;
}

const AdminLink = (props: AdminLinkProps) => {
  const features: FeatureFlags = useSelector(
    ({ sys }: ApplicationState) => sys.features
  );

  const { title, route, children } = props;

  return features?.frontendAdmin ? (
    <a href={route} title={title} target="_blank" rel="noreferrer">
      <FontAwesomeIcon icon="cogs" /> {children}
    </a>
  ) : null;
};

export default AdminLink;
